import { Box, Card, IconButton } from '@mui/material'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WTypography from 'Components/whiteTypography'

import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined'
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined'
import { DataGrid } from '@mui/x-data-grid'
import { makePutRequest } from 'utils/api'
import urls from 'utils/urls'
import CreateTache from 'containers/MesToDo/CreateTache'
import { makePostRequest } from 'utils/api'
import CreateEvent from 'containers/MesToDo/CreateEvent'
import { isEmpty } from 'lodash'
import { Stack } from 'react-bootstrap'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const columns = [
  {
    field: 'Nom',
    headerName: '',
    width: 80,
    editable: false,
  },
  {
    field: 'categorie',
    headerName: '',
    width: 80,
    editable: false,
    renderCell: (params) => {
      return <>{params.row.Nom}</>
    },
  },
  {
    field: 'Priorite',
    headerName: '',
    width: 220,
    editable: false,
    renderCell: (params) => {
      return <SelectBox params={params} />
    },
  },
  {
    field: 'DateCreation',
    headerName: '',
    width: 100,
    editable: false,
  },
  {
    field: 'Couts',
    headerName: '',
    width: 60,
    editable: false,
  },
  {
    field: 'DateLimite',
    headerName: '',
    width: 100,
    editable: false,
  },
  {
    field: 'Descriptions',
    headerName: '',
    width: 100,
    editable: false,
  },
  {
    field: 'project',
    headerName: '',
    width: 100,
    editable: false,
    renderCell: (params) => {
      return <>{params.row.project.Name}</>
    },
  },
  {
    field: 'liste',
    headerName: '',
    width: 100,
    editable: false,
    renderCell: (params) => {
      return <>{params.row.liste.Name}</>
    },
  },
]
// Priority DB values (French) kept as `value`; display via i18n. LAP-733 (GE022)
const priorite = [
  { value: 'Important et urgent', labelKey: 'syntheseTemps.priorityImportantUrgent', id: 1 },
  { value: 'Important et non urgent', labelKey: 'syntheseTemps.priorityImportantNotUrgent', id: 2 },
  { value: 'Non-important et urgent', labelKey: 'syntheseTemps.priorityNotImportantUrgent', id: 3 },
  { value: 'Non-important et non-urgent', labelKey: 'syntheseTemps.priorityNotImportantNotUrgent', id: 4 },
]
const SelectBox = ({ params }) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const handleChange = (event) => {
    const payload = {
      Priorite: event.target.value,
    }
    makePutRequest(urls.taskOperations + params.id + '/', payload, {}, true)
  }
  return (
    <Box key={params.id}>
      <select style={{ minWidth: 'max-content' }} onChange={handleChange}>
        {priorite.map((item, idx) => {
          return (
            <option
              key={idx}
              selected={params.row.Priorite === item.value ? true : false}
              value={item.value}
            >
              {t(item.labelKey)}
            </option>
          )
        })}
      </select>
    </Box>
  )
}
function ToDoCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const navigate = useNavigate()
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedRowsData, setSelectedRowsData] = useState({})
  const [createTache, setCreateTache] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [event, setEvent] = useState({})

  const toggleModal = () => {
    if (selectedRows.length === 0) {
      alert(t('syntheseTemps.selectOperationAlert'))
    } else if (selectedRows.length > 1) {
      alert(t('syntheseTemps.selectOperationAlert'))
    } else {
      // console.log(selectedRows)
      const row = oldData.filter((e) => e.id === selectedRows[0])
      // console.log(row)
      if (row.length > 0) setSelectedRowsData(row[0])
      setShowModal(!showModal)
    }
  }

  useEffect(() => {
    if (!isEmpty(event)) {
      insertEvent()
    }
  }, [event])
  const insertEvent = async () => {
    if (selectedRows.length === 0) {
      alert(t('syntheseTemps.selectOperationAlert'))
    } else if (selectedRows.length > 1) {
      alert(t('syntheseTemps.selectOperationAlert'))
    } else {
      const payload = {
        EventData: event,
      }
      const response = await makePutRequest(
        urls.taskOperations + selectedRows[0] + '/',
        payload,
        {},
        true,
      )
      if (response.status === 200) {
        setEvent({})
        updateReports()
      }
    }
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert(t('syntheseTemps.selectOperationAlert'))
    } else {
      const response = await makePostRequest(
        urls.deleteBulkTachesOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
        updateReports()
      }
    }
  }
  return (
    <>
      {createTache && <CreateTache setCreateTache={updateReports} />}
      {showModal && (
        <CreateEvent
          isOpen={showModal}
          toggleModal={toggleModal}
          setEvent={setEvent}
          row={selectedRowsData}
        />
      )}
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1 no-drag" onClick={() => navigate('/todos/taches')}>
          <WTypography component={'span'} variant="h6">
            {t('syntheseTemps.todoTitle')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {oldData.length}
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {t('syntheseTemps.todoSubtitle')}
          </WTypography>

          <Stack
            style={{
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}
            className="no-drag"
          >
            <IconButton sx={{ color: 'white' }} onClick={() => setCreateTache(true)}>
              <ControlPointOutlinedIcon />
            </IconButton>
            <IconButton sx={{ color: 'white' }} onClick={deleteBulkOperations}>
              <DoDisturbOnOutlinedIcon />
            </IconButton>
            <IconButton sx={{ color: 'white' }} onClick={toggleModal}>
              <CalendarMonthOutlinedIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box minWidth={3} mb={6} height={'100%'} borderTop={'1px solid white'}>
          {oldData.length > 0 && (
            <div
              style={{
                height: '100%',
                width: '100% ',
                background: 'unset',
                borderRadius: '5px',
                '.MuiDataGridMain': {
                  color: 'white',
                },
              }}
            >
              <DataGrid
                className="no-drag"
                style={{
                  color: 'white',
                  border: 'unset',
                }}
                sx={{
                  '.MuiDataGrid-cellCheckbox': {
                    color: 'white',
                  },
                  '.MuiDataGrid-cell': {
                    borderBottom: 'unset',
                    maxHeight: 'fit-content !important',
                    minHeight: 'fit-content !important',
                    whiteSpace: 'unset !important',
                    padding: '1px 0',
                  },
                  '.MuiCheckbox-root': {
                    color: 'white',
                  },
                  '.Mui-checked': {
                    color: 'white !important',
                  },
                  '.MuiDataGrid-row': {
                    maxHeight: 'fit-content !important',
                    minHeight: 'fit-content !important',
                    borderBottom: '1px solid #656565',
                    alignItems: 'center',
                  },
                  '& .MuiDataGrid-columnHeaders': { display: 'none' },
                  '& .MuiDataGrid-virtualScroller': { overflow: 'unset', marginTop: '0!important' },
                }}
                rows={oldData}
                columns={columns}
                rowsPerPageOptions={[10, 20, 40, 80, 100]}
                pagination
                onSelectionModelChange={(itm) => setSelectedRows([...itm])}
                paginationMode="server"
                checkboxSelection
                disableSelectionOnClick
                hideFooter
                hideFooterPagination
                disableColumnMenu
                columnHeaderHeight={0}
              />
            </div>
          )}
        </Box>
      </Card>
    </>
  )
}

export default ToDoCard
